import React from 'react';
import PropTypes from 'prop-types';
import { MenuItem } from 'react-bootstrap';

import { filterMaakunta } from '../../reducers/filter';
import Dropdown from './Dropdown.jsx';
import scopeTextsMaakunta from '../../texts';

const id = 'dropdown-maakunta';
const title = 'Maakunta';
const values = [
  { key: '0', text: '-' },
  { key: 'Ahvenanmaa', text: scopeTextsMaakunta(11) },
  { key: 'Etelä-Karjala', text: scopeTextsMaakunta(12) },
  { key: 'Etelä-Pohjanmaa', text: scopeTextsMaakunta(13) },
  { key: 'Etelä-Savo', text: scopeTextsMaakunta(14) },
  { key: 'Kainuu', text: scopeTextsMaakunta(15) },
  { key: 'Kanta-Häme', text: scopeTextsMaakunta(16) },
  { key: 'Keski-Pohjanmaa', text: scopeTextsMaakunta(17) },
  { key: 'Keski-Suomi', text: scopeTextsMaakunta(18) },
  { key: 'Kymenlaakso', text: scopeTextsMaakunta(19) },
  { key: 'Lappi', text: scopeTextsMaakunta(20) },
  { key: 'Pirkanmaa', text: scopeTextsMaakunta(21) },
  { key: 'Pohjanmaa', text: scopeTextsMaakunta(22) },
  { key: 'Pohjois-Karjala', text: scopeTextsMaakunta(23) },
  { key: 'Pohjois-Pohjanmaa', text: scopeTextsMaakunta(24) },
  { key: 'Pohjois-Savo', text: scopeTextsMaakunta(25) },
  { key: 'Päijät-Häme', text: scopeTextsMaakunta(26) },
  { key: 'Satakunta', text: scopeTextsMaakunta(27) },
  { key: 'Uusimaa', text: scopeTextsMaakunta(28) },
  { key: 'Varsinais-Suomi', text: scopeTextsMaakunta(29) }
];

const DropdownMaakunta = ({ changeFilter }) => (
  <Dropdown id={id} defaultTitle={title} filter={filterMaakunta} changeFilter={changeFilter}>
    {values.map(item => <MenuItem key={item.key} eventKey={item.key}>{item.text}</MenuItem>)}
  </Dropdown>
);

DropdownMaakunta.propTypes = {
  changeFilter: PropTypes.func.isRequired
};

export default DropdownMaakunta;



// WEBPACK FOOTER //
// ./src/components/eventFilter/DropdownMaakunta.jsx